import React, { Component } from "react";
import { loading, alert, float } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import HeroGameOne from "../assets/images/game/image-02.png";
import HeroGameTwo from "../assets/images/game/image-14.png";
import HeroGameThree from "../assets/images/game/image-39.png";
import HeroGameFour from "../assets/images/game/image-58.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: "",
      phone: "",
      email: "",
      password: "",
      password_view: "password",
    };
  }

  componentDidMount() {
    loading(false);
  }

  Register = async () => {
    const { fullname, phone, email, password } = this.state;
    if (!fullname) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-นามสกุล");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!password) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่าน");
      return;
    }

    await fetch(
      `${"https://swiftgamepay-default-rtdb.asia-southeast1.firebasedatabase.app/"}user/${email.split("@")[0]}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullname: fullname,
          phone: phone,
          email: email,
          password: btoa(password),
        }),
      }
    );

    alert(
      "login",
      "success",
      "สำเร็จ",
      "การสมัครสมาชิกของท่านเสร็จสมบูรณ์แล้ว"
    );
  };

  render() {
    const { fullname, phone, email, password, password_view } = this.state;

    return (
      <div className="login-page w-100 min-vh-100 position-relative overflow-hidden">
        <div className="login-page__ambient login-page__ambient--one"></div>
        <div className="login-page__ambient login-page__ambient--two"></div>
        <div className="login-page__grid"></div>

        <Navbar />

        <div className="container position-relative py-4 py-lg-5">
          <div className="login-shell row g-0 overflow-hidden">
            <div className="col-12 col-lg-5">
              <div className="login-form-panel">
                <span className="login-kicker">Create Account</span>
                <h1 className="login-title">สมัครสมาชิก</h1>
                <p className="login-description">
                  สร้างบัญชีเพื่อเริ่มเติมเกม เลือกแพ็กยอดนิยม
                  และใช้งานบริการของ Lvup Topup ได้สะดวกในที่เดียว
                </p>

                <label className="login-label">ชื่อ-นามสกุล</label>
                <input
                  className="form-control login-input mb-3"
                  type="text"
                  placeholder="ชื่อ-นามสกุล"
                  onChange={(e) => {
                    this.setState({ fullname: e.target.value });
                  }}
                  value={fullname}
                />

                <label className="login-label">เบอร์โทร</label>
                <input
                  className="form-control login-input mb-3"
                  type="text"
                  placeholder="เบอร์โทร"
                  maxLength={10}
                  onChange={(e) => {
                    if (!float(e.target.value)) {
                      return;
                    }
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                />

                <label className="login-label">อีเมล</label>
                <input
                  className="form-control login-input mb-3"
                  type="text"
                  placeholder="อีเมล"
                  onChange={(e) => {
                    this.setState({ email: e.target.value });
                  }}
                  value={email}
                />

                <label className="login-label">รหัสผ่าน</label>
                <div className="position-relative">
                  <input
                    className="form-control login-input mb-3"
                    type={password_view}
                    placeholder="รหัสผ่าน"
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Register();
                      }
                    }}
                    value={password}
                  />
                  <div
                    className="login-password-toggle icon pointer position-absolute"
                    onClick={() => {
                      this.setState({
                        password_view:
                          password_view === "password" ? "text" : "password",
                      });
                    }}
                  >
                    {password_view === "password" ? "\uf06e" : "\uf070"}
                  </div>
                </div>

                <button
                  type="button"
                  className="btn login-submit w-100 mb-3"
                  onClick={() => {
                    this.Register();
                  }}
                >
                  สมัครสมาชิก
                </button>

                <div className="login-links text-center">
                  <a className="text-decoration-none" href="/login">
                    เข้าสู่ระบบ
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-7 d-none d-lg-block">
              <div className="login-visual-panel">
                <div className="login-visual__glow login-visual__glow--gold"></div>
                <div className="login-visual__glow login-visual__glow--blue"></div>

                <div className="login-visual__card login-visual__card--back">
                  <img src={HeroGameTwo} alt="" />
                </div>
                <div className="login-visual__card login-visual__card--left">
                  <img src={HeroGameOne} alt="" />
                </div>
                <div className="login-visual__card login-visual__card--right">
                  <img src={HeroGameThree} alt="" />
                </div>
                <div className="login-visual__card login-visual__card--front">
                  <img src={HeroGameFour} alt="" />
                </div>

                <div className="login-brand-stage">
                  <span className="login-brand-stage__badge">
                    GAME TOP-UP STORE
                  </span>
                  <div className="login-brand-stage__wordmark">Lvup Topup</div>
                  <p>
                    สมัครสมาชิกเพื่อเริ่มเติมเกม เลือกแพ็กที่ต้องการ
                    และใช้งานบริการได้อย่างมั่นใจตลอด 24 ชม.
                  </p>
                  <div className="login-brand-stage__chips">
                    <span>Game Member</span>
                    <span>Trusted Service</span>
                    <span>Top-up Access</span>
                  </div>
                </div>

                <div className="login-visual__token login-visual__token--one">
                  720 Diamonds
                </div>
                <div className="login-visual__token login-visual__token--two">
                  325 UC
                </div>
                <div className="login-visual__token login-visual__token--three">
                  Bonus Coins
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
